import { ACTIONS } from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouteDefinition[]} */
const caseManagementRoutes = [
    {
        action: ACTIONS.ACTIVITY_SUPPORT_PLANS_GLOBAL_LIST,
        component: () => import("./ActivitySupportPlans/List/ActivitySupportPlansList.svelte"),
        title: "Activity Support Plans"
    },
    {
        action: ACTIONS.ACTIVITY_SUPPORT_PLAN_MANAGE,
        component: () => import("./ActivitySupportPlans/Form/ActivitySupportPlanForm.svelte"),
        title: "Manage Activity Support Plan"
    },
    {
        action: ACTIONS.CASE_NOTES_GLOBAL_LIST,
        component: () => import("./CaseNotes/List/CaseNotesList.svelte"),
        title: "Case Notes"
    },
    {
        action: ACTIONS.CRITICAL_INCIDENTS_GLOBAL_LIST,
        component: () => import("./CriticalIncidents/List/CriticalIncidentsList.svelte"),
        title: "Critical Incidents"
    },
    {
        action: ACTIONS.DOCUMENTS_GLOBAL_LIST,
        component: () => import("./Documents/List/DocumentsList.svelte"),
        title: "Documents"
    },
    {
        action: ACTIONS.GOALS_REVIEW_MANAGE,
        component: () => import("./GoalsReviews/Form/GoalsReviewForm.svelte")
    },
    {
        action: ACTIONS.GOALS_REVIEW_GLOBAL_LIST,
        component: () => import("./GoalsReviews/List/GoalsReviewsList.svelte")
    },
    {
        action: ACTIONS.ICAP_MANAGE,
        component: () => import("./Icaps/Form/IcapForm.svelte")
    },
    {
        action: ACTIONS.ICAP_GLOBAL_LIST,
        component: () => import("./Icaps/List/IcapsList.svelte")
    },
    {
        action: ACTIONS.HEALTH_REVIEW_CHECKLIST_MANAGE,
        component: () => import("./HealthReviewChecklists/Form/HealthReviewChecklistForm.svelte"),
        title: "Manage Health Review Checklist"
    },
    {
        action: ACTIONS.HEALTH_REVIEW_CHECKLIST_GLOBAL_LIST,
        component: () => import("./HealthReviewChecklists/List/HealthReviewChecklistsList.svelte"),
        title: "Health Review Checklists"
    },
    {
        action: ACTIONS.CHECKLISTS_HOME_VISITS_MANAGE,
        component: () => import("./HomeVisits/Form/HomeVisitForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_HOME_VISITS_GLOBAL_LIST,
        component: () => import("./HomeVisits/List/HomeVisitsList.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_QSS_525_MANAGE,
        component: () => import("./QualitySatisfactionSurveys525/Form/QualitySatisfactionSurvey525Form.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_QSS_525_GLOBAL_LIST,
        component: () => import("./QualitySatisfactionSurveys525/List/QualitySatisfactionSurveys525List.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_QSS_MANAGE,
        component: () => import("./QualitySatisfactionSurveys/Form/QualitySatisfactionSurveyForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_QSS_GLOBAL_LIST,
        component: () => import("./QualitySatisfactionSurveys/List/QualitySatisfactionSurveysList.svelte")
    },
    {
        action: ACTIONS.SENTINEL_EVENT_FORMS_GLOBAL_LIST,
        component: () => import("./SentinelEventForms/List/SentinelEventFormsList.svelte")
    },
    {
        action: ACTIONS.SENTINEL_EVENT_FORM_MANAGE,
        component: () => import("./SentinelEventForms/Form/SentinelEventForm.svelte")
    },
    {
        action: ACTIONS.SERVICE_NOTES_GLOBAL_LIST,
        component: () => import("./ServiceNotes/List/ServiceNotesList.svelte"),
        title: "Service Notes"
    },
    {
        action: ACTIONS.PLANNING_TEAM_ATTESTATION_GLOBAL_LIST,
        component: () => import("./PlanningTeamAttestation/List/PlanningTeamAttestationsList.svelte")
    },
    {
        action: ACTIONS.UNUSUAL_INCIDENTS_GLOBAL_LIST,
        component: () => import("./UnusualIncidents/List/UnusualIncidentsList.svelte"),
        title: "Unusual Incidents List"
    },
    {
        action: ACTIONS.UNUSUAL_INCIDENT_MANAGE,
        component: () => import("./UnusualIncidents/Form/UnusualIncidentForm.svelte"),
        title: "Manage Unusual Incident"
    }
];

export default caseManagementRoutes;